import { render, staticRenderFns } from "./Home4.vue?vue&type=template&id=dbd4e558&scoped=true"
import script from "./Home4.vue?vue&type=script&lang=js"
export * from "./Home4.vue?vue&type=script&lang=js"
import style0 from "./Home4.vue?vue&type=style&index=0&id=dbd4e558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4e558",
  null
  
)

export default component.exports